import type { InferOutput } from "valibot";
import { object } from "valibot";
import type { VariableDefinition } from "../Variable";
import { initVariable, VariableBaseSchema } from "../Variable";
import { strippedIsoDateTime, require } from "../../utils/validation/base";
import { keyFromSelector } from "i18next";

const Schema = object({
  ...VariableBaseSchema.entries,
  defaultValue: require(strippedIsoDateTime()),
});

export type DateTimeVariableType = InferOutput<typeof Schema>;

const DateTimeVariable: VariableDefinition<DateTimeVariableType> = {
  type: "datetime",
  icon: "dateTime",
  schema: Schema,
  ruleConditionBehaviour: {
    variant: "text",
    keys: ["hasValue"],
  },
  titleKey: keyFromSelector(($) => $.DATE_TIME_VARIABLE_LABEL),
};

export default initVariable(DateTimeVariable);
